import React, { Component,Suspense } from "react";
import Carousel from "react-spring-3d-carousel";
import { config } from "react-spring";

// import GunModel from "./Model";
import styled from "styled-components";
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';


const CanvasWrappper = styled(Canvas)`
width:100%;
align-items:center;
justify-content:center;
display:flex;
padding-top:${(p) => p.theme.spacing.lg};
`;
const Span = styled.div`
margin:0 ${(p) => p.theme.spacing.xs};
`;
export default class ImagesSlide extends Component {
  state = {
    goToSlide: 0,
    offsetRadius: 5,
    showNavigation: true,
    config: config.gentle,
    dots: true,
  };

  // Imagelist = [
  //   {
  //     content: <img src={NFTImage1} alt="1" />,
  //     data:<GunModel/>
  //   },
  //   {
  //     content: <img src={NFTImage2} alt="1" />,
  //     data:<GunModel/>
  //   },
  //   {
  //     content: <img src={NFTImage3} alt="1" />,
  //     data:<GunModel/>
  //   },
  //   {
  //     content: <img src={NFTImage4} alt="1" />,
  //     data:<GunModel/>
  //   },
  //   {
  //     content: <img src={NFTImage5} alt="1" />,
  //     data:<GunModel/>
  //   },
  // ];

  slides = this.Imagelist.map((slide, index) => {
    return { ...slide, onClick: () => this.setState({ goToSlide: index }) };
  });

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: parseInt(e.target.value, 10) || 0,
    });
  };

  render() {
    return (
      <div style={{ width: "50%", height: "250px", margin: "0 auto" }}>
        <Carousel
          slides={this.slides}
          goToSlide={this.state.goToSlide}
          offsetRadius={this.state.offsetRadius}
          animationConfig={this.state.config}
          moveSlide
        />
        <div style={{ width: "100px", height: "50px" }}>
          <img
            src={this.Imagelist[this.state.goToSlide].content.props.src}
            style={{width: "100%"}}
            alt="1"
          />
           <CanvasWrappper style={{ width: '100%', height: '400px' }} camera={{ position: [150, 50, 50], zoom: 1.5, near: 1, far: 1000, fov: 50 }}>
                            <Suspense fallback={null}>
                                <ambientLight />
                                {this.Imagelist[this.state.goToSlide].data}
                                <OrbitControls
                                    enablePan={true}
                                    enableZoom={true}
                                    enableRotate={true}
                                    autoRotate={true}
                                />
                            </Suspense>
                        </CanvasWrappper>
         
        </div>
      </div>
    );
  }
}
